import React from 'react'
import ProcessCards from '../../../components/landingPage/Cards/ProcessCards'
import Section from '../../landingPage/Section'
import {Partners, DigitalDentist, PatientData, Patients, PartnersLabs} from '../../../images/index'
import Button from '../../../components/landingPage/Button'

const HEIGHT_STYLE = {
  minHeight:"min-content"
}

function ProcessSection() {
  var lineStyle = {
    borderLeft:"2px dashed black",
    minHeight:"100%",
    transform:"translateX(4.5px)"
  }

  var bulletpoint = {
    transform: "translateY(-10px) translateX(-6px)",
    marginTop:"20px"
  }

  return (
    <Section title="Our Process" className="bg-gray-50 h-auto pb-8 md:pb-12" id="Process">
      <div className="relative flex justify-center" style={HEIGHT_STYLE}>
        <div style={lineStyle} className="lg:absolute lg:inset-0 mx-4 lg:mx-auto w-2 z-0 flex flex-col justify-around items-start">
          <span className="z-1 rounded-full w-2.5 h-2.5 border-2 border-primary bg-white" style={bulletpoint}/>
          <span className="z-1 rounded-full w-2.5 h-2.5 border-2 border-primary bg-white" style={bulletpoint}/>
          <span className="z-1 rounded-full w-2.5 h-2.5 border-2 border-primary bg-white" style={bulletpoint}/>
          <span className="z-1 rounded-full w-2.5 h-2.5 border-2 border-primary bg-white" style={bulletpoint}/>
          <span className="z-1 rounded-full w-2.5 h-2.5 border-2 border-primary bg-white" style={bulletpoint}/>
          <div className="border-b-2 border-r-2 h-3 w-3 border-primary absolute -bottom-3 mx-auto transform rotate-45 -inset-x-4 -right-2"></div>
        </div>
        
        <div className="grid lg:grid-cols-2 lg:grid-rows-5">
          <ProcessCards icon={Partners} text="Partners first get secure access to the XiViX platform & equipment" className="py-2 lg:pr-5 lg:flex-row-reverse lg:place-self-end col-span-1" classText="lg:text-right"/>
          <ProcessCards icon={DigitalDentist} text="The Digital Dentist/CoE receives patients for a quick Scan & Go" className="py-2 lg:pl-5 lg:place-self-start lg:col-start-2 lg:row-start-2"/>
          <ProcessCards icon={PatientData} text="Patient data is transmitted securely to the CIPP for analysis, design treatment planning and prosthesis production" className="py-2 lg:pr-5 lg:flex-row-reverse lg:place-self-end lg:col-span-1 lg:row-start-3" classText="lg:text-right"/>
          <ProcessCards icon={Patients} text="Patients are sent to the Digital Dentist/CoE for procedures by specialists and the final fitting" className="py-2 lg:pl-5 lg:place-self-start lg:col-start-2 lg:row-start-4"/>
          <ProcessCards icon={PartnersLabs} text="Partners labs take over the fabrication and finishing of prostheses" className="py-2 lg:pr-5 lg:flex-row-reverse lg:place-self-end lg:col-span-1 lg:row-start-5" classText="lg:text-right"/>
        </div>
      </div>
      <div className="max-w-max mt-10 mx-auto">
        <div className={`text-lpGray border border-lpGray  text-xs sm:text-base sm:px-4 py-2 rounded h-10 px-3`}>
          ALL COMMUNICATION TAKES PLACE VIA THE XiViX PLATFORM
        </div>
      </div>
    </Section>
  )
}

export default ProcessSection
